export default __webpack_public_path__ + "static/media/activity3.fe57ed25.jpg";